import { BaseRestoreFormsModel } from 'wizards/models/base/base-restore-forms-model';
import { RestoreSourceStepValue } from 'wizards/models/restore-source-models';
import { SQLServerInstanceAuthenticationTypeEnum, SQLServerInstanceStepValue } from 'wizards/models/sql-server-instance-models';
import { DefaultTemplate, DestinationDBStepValue } from '../destination-db-models';

export class RestoreDatabaseFormModel extends BaseRestoreFormsModel {
  sqlServerInstanceStep?: SQLServerInstanceStepValue;

  restoreSourceStep: RestoreSourceStepValue = { folders: [], valid: true };
  destinationStep: DestinationDBStepValue = {
    destinationFolder: '',
    createFolder: false,
    backupTemplate: DefaultTemplate,
    valid: true
  };

  constructor(public isNBF = false, isRestoreDatabase = false) {
    super(isNBF);

    if (isRestoreDatabase) {
      this.sqlServerInstanceStep = {
        sqlServerInstanceName: '',
        authenticationType: SQLServerInstanceAuthenticationTypeEnum['Windows Authentication'],
        userName: '',
        password: '',
        useSecureConnection: false,
        checkIsSysAdmin: true,
        valid: false
      };
    }
  }
}
